<script>
  /* Executable code section of the program */
  //Tools Importation
  import { alertMessagge, isAlertOn, isModalEventsOn, isModalUpdate, isReloadNecessary, objData } from "../../apis/storage";
  import { getCollection, postDocument, updateDocument,updateMultipleDocuments } from "../../apis/APIS";
  import { element } from "svelte/internal";

  //Auxiliary Variables
  let data = {};
  let coordinatorArray = []

  if ($isModalEventsOn) {
    $objData.tittle = "";
    $objData.country = "";
    $objData.place = "";
    $objData.eventDate = {};
    $objData.eventDate.startDate = "";
    $objData.eventDate.endDate = "";
    $objData.eventMultimedia = {};
    $objData.eventMultimedia.eventImgUrl = "";
    $objData.eventMultimedia.eventVideoUrl = "";
    $objData.eventMultimedia.eventWallpaperUrl = "";
    $objData.colorEvent = "#fffff";
    $objData.networkingBreaks = [];
    $objData.customTables = []
    $objData.eventButtons = []
    $objData.activeChat = true
  }

  //Function to undisplay modal
  const undisplayModal = () => {
    $isModalEventsOn = false;
    $isModalUpdate = false;
    $objData = {}
  };

  //Function to get eventDays
  const getEventDays = (startDate, numberDays) => {
    const datesArray = [];
    let currentDate = new Date(startDate);

    for (let i = 0; i < numberDays; i++) {
      const day = currentDate.getDate() + 1;
      const month = currentDate.toLocaleDateString("en-US", { month: "long" });
      const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
      const formattedDate = `${day} / ${capitalizedMonth}`;

      datesArray.push({
        eventDay: formattedDate,
        programmedBreaks: [],
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return datesArray;
  };

  //Function to get totally days for event
  const getTotallyDays = (startDate, endDate) => {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date2 - date1);

    // Convert the difference from milliseconds to days and add 1 to include both ends
    const differenceDays = Math.ceil(differenceMs / (1000 * 60 * 60 * 24)) + 1;

    return differenceDays;
  };

  //Function to display alert
  const displayAlert = () =>{
    $isAlertOn = true
  }

  //Function to verify data before postDocument
  const verifyData = () => {
    if (
      $objData.tittle === "" ||
      $objData.country == "" ||
      $objData.place == "" ||
      $objData.startDate == "" ||
      $objData.endDate == ""
    ) {
      $alertMessagge = "Fields marked with this sign (*) cannot be left empty";
      displayAlert()
    } else {
      if ($isModalEventsOn) {
        $objData.eventDate.daysDuration = getTotallyDays(
          $objData.eventDate.startDate,
          $objData.eventDate.endDate
        );
        $objData.eventButtons =[
          {
          buttonTittle:"Meetings",
          buttonUrl: "#meetings",
          isAvailable:true
        },{
          buttonTittle:"Attendees",
          buttonUrl: "#attendees",
          isAvailable:true
        },{
          buttonTittle:"Polls",
          buttonUrl: "#polls",
          isAvailable:false
        },
      ]
        $objData.networkingBreaks = getEventDays($objData.eventDate.startDate,$objData.eventDate.daysDuration)
        $objData.scheduledMeets = [];
        postDocument("events", $objData).then(async()=>{
          let updateCoordinatorsArray = []
          coordinatorArray = await getCollection("coordinators")
          
          if (coordinatorArray.length>0) {
            
            coordinatorArray.forEach(element => {
              
              updateCoordinatorsArray.push({
                id:element.id,
                fieldName:"myChats",
                values:[{
            chatId: $objData.tittle,
            eventTittle: $objData.tittle,
            eventCountry: $objData.country,
            eventPoster: $objData.eventMultimedia.eventImgUrl}]
              })
            })            
            updateMultipleDocuments("users",updateCoordinatorsArray)
          }
          $alertMessagge = "Event created successfully`";
          $isReloadNecessary = true 
          displayAlert()
          $isModalEventsOn = false;
          })
          .catch(()=>{
          $alertMessagge = "An error occurred while creating the event." 
          displayAlert()
          })
      } else {
        updateDocument("events", $objData, $objData.id).then(()=>{
          $alertMessagge = "Event updated successfully`";
          $isReloadNecessary = true
          displayAlert()
          $isModalUpdate = false;
          })
          .catch(()=>{
          $alertMessagge = "An error occurred while creating the event." 
          displayAlert()
          })
      }
    }
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="sectionContainer">
  <div class="contentModal">
    <div class="closeSection">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-x-circle icon"
        viewBox="0 0 16 16"
        on:keypress={() => undisplayModal()}
        on:click={() => undisplayModal()}
      >
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
        />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
        />
      </svg>
    </div>
    <div class="contentFormModal">
      {#if $isModalEventsOn}
        <h2>Create Events</h2>
      {:else}
        <h2>Update Event</h2>
      {/if}
      <!-- General information section -->
      <h4 class="subtittle">General Information</h4>
      <div class="containerInputs">
        <div class="form-floating textInputs">
          <input
            type="text"
            class="form-control floatingPassword"
            placeholder="Tittle Event"
            bind:value={$objData.tittle}
          />
          <label for="floatingPassword">Tittle Event</label>
          
        </div>
        <div class="form-floating textInputs">
          <input
            type="text"
            class="form-control floatingPassword"
            placeholder="Country"
            bind:value={$objData.country}
          />
          <label for="floatingPassword">Country</label>
          
        </div>
        <div class="form-floating textInputs">
          <input
            type="text"
            class="form-control floatingPassword"
            placeholder="Country"
            bind:value={$objData.place}
          />
          <label for="floatingPassword">Place Name</label>
          
        </div>
        <div class="form-floating textInputs">
          <input
            type="date"
            class="form-control floatingPassword"
            placeholder="Tittle Event"
            bind:value={$objData.eventDate.startDate}
          />
          <label for="floatingPassword">Start Date</label>
          
        </div>
        <div class="form-floating textInputs">
          <input
            type="date"
            class="form-control floatingPassword"
            placeholder="Country"
            bind:value={$objData.eventDate.endDate}
          />
          <label for="floatingPassword">End Date</label>
          
        </div><div class="form-floating textInputs">
          <input
            type="number"
            class="form-control floatingPassword"
            placeholder="Total Tables"
            bind:value={$objData.tablesNumber}
          />
          <label for="floatingPassword">Total Tables</label>
          
        </div>
      </div>
      <!-- End section -->

      <!-- Multimedia section -->
      <h4 class="subtittle">Multimedia information</h4>
      <div class="containerInputs">
        <div class="form-floating linksInput">
          <input
            type="text"
            class="form-control"
            placeholder="Tittle Event"
            bind:value={$objData.eventMultimedia.eventImgUrl}
          />
          <label for="floatingPassword">Event Image Link</label>
          
        </div>
        <div class="form-floating linksInput">
          <input
            type="text"
            class="form-control"
            placeholder="Country"
            bind:value={$objData.eventMultimedia.eventVideoUrl}
          />
          <label for="floatingPassword">Event Video Link</label>
          
        </div>
        <div class="form-floating linksInput">
          <input
            type="text"
            class="form-control"
            placeholder="Country"
            bind:value={$objData.eventMultimedia.eventWallpaperUrl}
          />
          <label for="floatingPassword">Event Wallpaper Link</label>
        </div>
      </div>
      <!-- End section -->
      <!-- Description information section -->
      <h4>Description Information</h4>
      <div class="containerInputs">
        <div class="form-floating textAreaInput">
          <textarea
            class="form-control"
            placeholder="Leave a comment here"
            id="floatingTextarea2"
            style="height: 100px"
            bind:value={$objData.eventDescription}
          ></textarea>
          <label for="floatingTextarea2">Event Description</label>
        </div>
      </div>
      <!-- End section -->
      <h4 for="exampleColorInput" class="form-label">Color Event Picker</h4>
      <input
        bind:value={$objData.colorEvent}
        type="color"
        class="form-control form-control-color"
        id="exampleColorInput"
        title="Choose your color"
      />
    </div>
    <div class="buttonsSection">
      <button class="actionBtn" on:click={() => undisplayModal()}>Close</button>
      {#if $isModalEventsOn}
        <button class="actionBtn addEventBtn" on:click={verifyData}
          >Add Event</button
        >
      {:else}
        <button class="actionBtn addEventBtn" on:click={verifyData}
          >Update Event</button
        >
      {/if}
    </div>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .sectionContainer {
    position: fixed;
    top: 0;
    z-index: 888;
    width: 100%;
    height: auto;
    background-color: rgba(0, 0, 0, 0.432);
    display: flex;
    justify-content: center;
    padding: 30px 0;
  }
  .contentModal {
    width: 80%;
    height: auto;
    max-height: 90dvh;
    overflow: auto;
    background-color: white;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* Icon styles section */
  .closeSection {
    width: 90%;
    padding: 10px;
    display: flex;
    justify-content: flex-end;
  }
  .icon:hover {
    cursor: pointer;
    color: red;
  }
  /* Content styles section */
  .contentFormModal {
    width: 90%;
    padding: 20px;
  }
  .containerInputs {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid gray;
  }
  h4 {
    color: rgba(0, 0, 0, 0.822);
    margin: 35px 15px;
  }
  .textInputs {
    width: 30%;
    margin: 10px 15px;
  }
  .linksInput {
    width: 40%;
    margin: 10px 15px;
  }
  .textAreaInput {
    width: 70%;
    margin: 10px 15px;
  }

  .form-control {
    width: 100%;
  }
  .form-control-color {
    width: 5%;
    margin: 15px;
  }

  /* Buttons final styles section */
  .buttonsSection {
    width: 90%;
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid gray;
  }
  h2 {
    border-bottom: 1px solid gray;
  }
  .actionBtn {
    width: 150px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .form-control-color {
      width: 15%;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .contentModal {
      width: 90%;
      height: auto;
      min-height: 80vh;
      background-color: white;
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    h2 {
      font-size: 35px;
    }
    h4{
      margin: 5px;
    }
    .contentFormModal {
      width: 100%;
      padding: 20px;
    }
    .containerInputs {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 5px;
    }
    .textInputs {
      width: 100%;
      padding: 0;
      margin: 5px;
    }
  .linksInput {
    width: 100%;
    margin: 5px;
  }
  
  .textAreaInput {
    width: 100%;
    margin: 5px;
  }
    .form-control-color {
      width: 50%;
    }
    .buttonsSection {
      width: 100%;
      align-items: center;
      padding: 10px;
    }
    .actionBtn {
      width: 90%;
      height: auto;
      margin: 10px;
      padding: 10px 20px;
      font-size: 20px;
    }
  }
  /* End of the section */
</style>
